import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, IconButton, Icon, Row, Table, Message } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { saveProjectTemplate } from '../../redux/actions/projectTemplate'
import { doneLoading, startLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import { getSchemaSidebar } from '../../redux/actions/sidebar'

export default function ProjectProposalWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { schema, buttonText } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [selectId, setSelectId] = useState()

  const dispatch = useDispatch()
  let history = useHistory()

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  const handleSaveProjectTemplate = async (newSchama) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const _schema = await saveProjectTemplate(newSchama)
      await dispatch(getSchemaSidebar(_schema.projectVersionId))
      doneLoading()
      sessionStorage.setItem('projectId', _schema.projectVersionId)
      sessionStorage.setItem('param', '')

      history.push(`${pathname.proposal.projectName}`)
    } catch (e) {
      setIsError(true)
      setIsLoading(false)
      doneLoading()
    }
  }

  const onsubmit = (project, issues) => {
    const request = {
      id: project.id,
      name: project.name,
      fiscalYear: project.fiscalYear.value,
      proposalType: project.proposalType.value,
      start: project.openPeriod.start,
      end: project.openPeriod.end,
      department: project.department.value,
      detail: project.detail.value,
      issues: issues,
    }

    setSelectId(project.id)
    handleSaveProjectTemplate(request)
  }

  return (
    <>
      <div ref={containerRef}>
        {schema?.map((item) => {
          return (
            <Panel
              key={item.id}
              header={item.name}
              bordered
              collapsible
              defaultExpanded
              shaded
              style={{ marginBottom: 20 }}
            >
              {item.fiscalYear.value && (
                <p style={{ float: 'right', marginTop: 8, marginRight: 20 }}>
                  <b>{item.fiscalYear.label} : </b> {item.fiscalYear.value}
                </p>
              )}

              {item.proposalType.value && (
                <p>
                  <b>{item.proposalType.label} : </b>
                  {item.proposalType.value}
                </p>
              )}

              {item.openPeriod.start && item.openPeriod.end && (
                <p>
                  <b>{item.openPeriod.label} : </b>
                  {item.openPeriod.start} - {item.openPeriod.end}
                </p>
              )}

              {item.department.value && (
                <p>
                  <b>{item.department.label} : </b>
                  {item.department.value}
                </p>
              )}

              {item.detail.value && (
                <div>
                  <p>
                    <b>{item.detail.label} : </b>
                  </p>
                  <div
                    style={{ marginLeft: 20 }}
                    dangerouslySetInnerHTML={{ __html: item.detail.value }}
                  />
                </div>
              )}

              {selectId == item.id && isError && (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type="error" description={'ยื่นข้อเสนอโครงการไม่สำเร็จ'} />
                </Row>
              )}
              <Table wordWrap autoHeight data={item.issues.options} style={{ marginTop: 40 }}>
                <Column width={50}>
                  <HeaderCell></HeaderCell>
                  <Cell />
                </Column>
                <Column
                  width={containerWidth > 500 ? containerWidth - 50 - 200 - 42 : 250}
                  verticalAlign="middle"
                >
                  <HeaderCell>
                    <p>{item.issues.label}</p>
                  </HeaderCell>
                  <Cell dataKey="label" />
                </Column>

                <Column width={200} align="center" verticalAlign="middle">
                  <HeaderCell></HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return (
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="file-o" className="bt-gost-icon-radius" />}
                          onClick={(e) => onsubmit(item, rowData.value)}
                          disabled={isLoading}
                        >
                          {/* {`ยื่นข้อเสนอโครงการ`} */}
                          {buttonText ? buttonText : 'ยื่นข้อเสนอโครงการ'}
                        </IconButton>
                      )
                    }}
                  </Cell>
                </Column>
              </Table>
            </Panel>
          )
        })}
      </div>
    </>
  )
}
